import { useState } from "react";
import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_FAQS = [
  { question: "How quickly can you collect?", answer: "Same day in most cases if you book before noon. Most pickups are with you within 2 hours of booking." },
  { question: "What rubbish won't you take?", answer: "A short list: asbestos, clinical waste, large quantities of tyres, gas bottles, chemicals, radioactive waste, and Japanese knotweed. We can recommend specialist contractors for those." },
  { question: "Do I need a skip permit?", answer: "No — that's the whole point. With a man-and-van service, the van's only on site for the time it takes to load. No permit, no permission, no neighbour rows." },
  { question: "How do you charge?", answer: "By volume — quarter, half, three-quarters, or full van. Heavier loads (rubble, soil) factor weight into the quote up front. All-in pricing including labour, fuel, disposal, and VAT." },
  { question: "Are you licensed?", answer: "Yes — Environment Agency Licensed Waste Carrier. We're public-liability insured and we provide a waste-transfer note for every collection." },
  { question: "Do you cover commercial jobs?", answer: "Yes — offices, retail, building sites, landlord clear-outs. We can invoice, do credit accounts for regulars, and work out of hours. See office clearance or call." },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { data: homeCMS } = useCMSPage("home");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const faqCMS: any = (homeCMS as any)?.faq ?? {};

  const headline = faqCMS?.headline ?? "Got questions?";
  const faqs: { question: string; answer: string }[] = faqCMS?.items?.length ? faqCMS.items : DEFAULT_FAQS;

  return (
    <section className="py-20 bg-cl-tint">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">FAQs</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">{headline}</h2>
        </div>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white rounded-2xl cartoon-card overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left"
              >
                <span className="font-black text-cl-dark text-base">{faq.question}</span>
                <i className={`ri-arrow-${openIndex === i ? "up" : "down"}-s-line text-cl-green text-xl flex-shrink-0 ml-4`}></i>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 text-cl-dark/70 font-semibold text-sm leading-relaxed border-t-2 border-gray-100 pt-4">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
